/**
 * Created by tking on 20/07/2018.
 */

import {HttpService} from './http.service';
import {Injectable, InjectionToken} from '@angular/core';
import {IIataService} from './iata.interface';
import {Observable} from 'rxjs/Observable';
import {NotificationResult} from '../models/notification-result';
import {AuditableBaseResult} from '../models/auditable-base-result';
import {AuditableIataImport} from '../models/auditable-iata-import';
import {AuditableRestrictedIatas} from '../models/auditable-restricted-iatas'
import {RestrictedIata} from "../models/restricted-iata";
import {AuditableRestrictedIata} from "../models/auditable-restricted-iata";
import {Partner} from "../models/partner";

export const IATA_SERVICE_TOKEN = new InjectionToken<IIataService>('iata.service');

@Injectable()
export class IataService implements IIataService {

  constructor(private http: HttpService) {
  }

  isNonRestrictedIata(id: number): Observable<NotificationResult> {
    return this.http.sendGetRequest('iata/restrictediata/'  + id, AuditableBaseResult.parseActionResult);
  }

  importIata(data: string): Observable<AuditableIataImport> {
    return this.http.sendPostRequest('iata/import', JSON.stringify({ 'data': data }), AuditableIataImport.parseIataImportResponse);
  }

  getRestrictedIatas(): Observable<AuditableRestrictedIatas> {
    return this.http.sendGetRequest('iata/restrictediatas', AuditableRestrictedIatas.parseRestrictedIatasResponse);
  }

  editRestrictedIata(restrictedIata: RestrictedIata): Observable<AuditableRestrictedIata> {
    return this.http.sendPutRequest(`iata/restrictediatas/${restrictedIata.id}`, AuditableRestrictedIata.parseRestrictedIataJson(restrictedIata), AuditableRestrictedIata.parseRestrictedIataResponse);
  }

  addRestrictedIata(restrictedIata: RestrictedIata): Observable<AuditableRestrictedIata> {
    return this.http.sendPostRequest(`iata/restrictediatas`, AuditableRestrictedIata.parseRestrictedIataJson(restrictedIata), AuditableRestrictedIata.parseRestrictedIataResponse);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/iata.service.ts